import api from '@/apis/di/salaryScaleAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('salaryScale', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_salary_scale',
    field: {
      key: 'salary_scale_id',
      code: 'salary_scale_code',
      name: 'salary_scale_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
